import { EventEmitter, Injectable, Output } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { ResponseResults } from '../models/response-results.model';
import { DashboardScore } from '../models/dashboardScore.model';
import { environment } from '../../environments/environment';
import { TranslationService } from './translation.service';
import { LocalStorageService } from './localstorage.service';
import { FilterStatsService } from './filter.service';
import { SportsService } from './sport.service';
import { GenericService } from './generic.services';

@Injectable({
  providedIn: 'root',
})
export class ScoresSportsService {
  private urlAPI = environment.API;
  //  private scheduleAndResultsDiary = 'scheduleAndResultsDiary';
  private scheduleAndResultsDiaryNew = 'scheduleAndResultsDiaryNew';
  private scheduleAndResultsDiaryNotToday = 'scheduleAndResultsDiaryNotToday';
  private scheduleAndResultsDiaryById = 'scheduleAndResultsDiaryById';
  private scheduleAndResultsTodayById = 'scheduleAndResultsTodayById';
  private competitionById = 'competitionById';
  private matchesInLiveAll = 'matchesLiveFutbol';
  private matchesRefresh = 'matchesScheduleCompetitions';
  private standingCompetition = 'standingCompetitionById';

  public dashboardScores: Array<DashboardScore> = [];
  public matchInLive: Array<any> = [];
  public dashboardCompetitionsToday: Array<DashboardScore> = [];
  public dashboardCompetitionsNext: Array<{
    day: any;
    matches: DashboardScore;
  }> = [];

  @Output() isLoading = new EventEmitter<any>();

  constructor(
    private readonly translatorService: TranslationService,
    private readonly lsService: LocalStorageService,
    private filterServices: FilterStatsService,
    private http: HttpClient,
    public readonly sportsServices: SportsService,
    private readonly genericServices: GenericService
  ) {}

  /***
   * Obtain schedule of the matches today or other day
   */
  getScheduleResultsDiary(
    dateSelected: string,
    filter: string = 'All',
    today: boolean
    // hasSport: null
  ): Observable<boolean> {
    if (this.sportsServices.getSelectedSport() === 'Futbol') {
      return of(true);
    }

    this.isLoading.emit(true);
    const sport =
      this.sportsServices.getSelectedSport() === 'Futbol'
        ? ''
        : '/' + this.sportsServices.getSelectedSport();
    return this.http
      .post<any>(
        `${this.urlAPI}${
          today
            ? this.scheduleAndResultsDiaryNew
            : this.scheduleAndResultsDiaryNotToday
        }${sport}/${this.translatorService.getCurrentLanguage()}/${dateSelected}?filterSelected=${filter}`,
        {
          favoriteCompetitions:
            this.lsService.getFavoriteFromLocal('COMPETITION'),
          favoriteMatchs: this.lsService.getFavoriteFromLocal('MATCH'),
          dateUser: this.genericServices.getCurrentTimeUnix(
            !today ? dateSelected : ''
          ),
          timeZoneUser: this.genericServices.guessTimezone(),
          today,
        }
      )
      .pipe(
        map((result: ResponseResults) => {
          this.isLoading.emit(false);

          this.dashboardScores = result.data;
          this.filterServices.total.emit(result.total);
          this.filterServices.totalFinished.emit(result.totalFinished);
          this.filterServices.totalInLive.emit(result.totalInLive);
          this.filterServices.totalBeginNext.emit(result.totalBeginNext);
          return true;
        })
      );
  }

  /***
   * Obtain one competition by id
   */
  getCompetitionById(id: string, hasSport: any = null): Observable<any> {
    let sport = hasSport ? hasSport : this.sportsServices.getSelectedSport();
    sport = sport === 'Futbol' || sport === 'Favoritos' ? '' : `/${sport}`;

    return this.http.get<any>(
      `${this.urlAPI}${
        this.competitionById
      }${sport}/${this.translatorService.getCurrentLanguage()}/${id}`
    );
  }

  initTotalFilter() {
    this.filterServices.total.emit(0);
    this.filterServices.totalFinished.emit(0);
    this.filterServices.totalInLive.emit(0);
    this.filterServices.totalBeginNext.emit(0);
  }

  /***
   * Obtain incidents of the match status inlive
   */
  getMatchesInLive(): Observable<any> {
    return this.http.post<any>(
      `${this.urlAPI}${
        this.matchesInLiveAll
      }/${this.translatorService.getCurrentLanguage()}`,
      {
        timeZoneUser: this.genericServices.guessTimezone,
      }
    );
  }

  /***
   * Obtain incidents of the match status inlive
   */
  refreshMatchesSchedule(
    dateSelected: string,
    filter: string = 'All',
    hasSport = null
  ): Observable<any> {
    let sport: any = hasSport
      ? hasSport
      : this.sportsServices.getSelectedSport();
    sport =
      sport === 'Futbol' ? '' : `/${this.sportsServices.getSelectedSport()}`;

    return this.http.post<any>(
      `${this.urlAPI}${
        this.matchesRefresh
      }${sport}/${this.translatorService.getCurrentLanguage()}/${dateSelected}?filterSelected=${filter}`,
      {
        dateUser: this.genericServices.getCurrentTimeUnix(),
        timeZoneUser: this.genericServices.guessTimezone(),
      }
    );
  }

  /***
   * Obtain information of matches relantionship by ID team or competition
   */
  getScheduleResultsById(
    dateSelected: string,
    filter: string = 'All',
    id: string | null = null,
    type: string = 'All',
    today: boolean,
    hasSport: any = null
  ): Observable<any> {
    let sport = hasSport ? hasSport : this.sportsServices.getSelectedSport();
    sport = sport === 'Futbol' || sport === 'Favoritos' ? '' : `/${sport}`;

    return this.http
      .post<any>(
        `${this.urlAPI}${
          today
            ? this.scheduleAndResultsTodayById
            : this.scheduleAndResultsDiaryById
        }${sport}/${this.translatorService.getCurrentLanguage()}/${dateSelected}?filterSelected=${filter}${
          id ? '&id=' + id : ''
        }`,
        {
          favoriteCompetitions:
            this.lsService.getFavoriteFromLocal('COMPETITION'),
          favoriteMatchs: this.lsService.getFavoriteFromLocal('MATCH'),
          dateUser: this.genericServices.getCurrentTimeUnix(dateSelected),
          timeZoneUser: this.genericServices.guessTimezone(),
          type,
          today,
        }
      )
      .pipe(
        map((result: ResponseResults) => {
          return result;
        })
      );
  }

  /***
   * Obtain standings of competition by id
   */
  getStandingsCompetition(id: string): Observable<any> {
    const sport =
      this.sportsServices.getSelectedSport() === 'Futbol'
        ? ''
        : '/' + this.sportsServices.getSelectedSport();

    return this.http.get<any>(
      `${this.urlAPI}${
        this.standingCompetition + sport
      }/${this.translatorService.getCurrentLanguage()}/${id}`
    );
  }
}
